import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsByAgentIdReleasesInfiniteOptions } from '@onefootprint/fetch-dashboard';
import type { AgentVersionHistoryItem } from '@onefootprint/request-types/dashboard';
import { useInfiniteQuery } from '@tanstack/react-query';
const PAGE_SIZE = 100;
const useAgentReleases = (agentId, enabled) => {
  const $ = _c(20);
  const t0 = agentId ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = getOrgAgentsByAgentIdReleasesInfiniteOptions({
      path: {
        agentId: t0
      },
      query: {
        pageSize: PAGE_SIZE
      }
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = enabled && !!agentId;
  const t3 = agentId ?? "";
  let t4;
  if ($[2] !== t3) {
    t4 = {
      agentId: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      pageSize: PAGE_SIZE
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = {
      path: t4,
      query: t5
    };
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t6) {
    t7 = {
      ...t1,
      enabled: t2,
      initialPageParam: t6,
      getNextPageParam: _temp
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const query = useInfiniteQuery(t7);
  let t8;
  if ($[11] !== query.data?.pages) {
    t8 = query.data?.pages.flatMap(_temp2) ?? [];
    $[11] = query.data?.pages;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const items = t8;
  const t9 = !!query.hasNextPage;
  let t10;
  if ($[13] !== items || $[14] !== query.error || $[15] !== query.fetchNextPage || $[16] !== query.isFetchingNextPage || $[17] !== query.isLoading || $[18] !== t9) {
    t10 = {
      items,
      isLoading: query.isLoading,
      isFetchingNextPage: query.isFetchingNextPage,
      hasNextPage: t9,
      fetchNextPage: query.fetchNextPage,
      error: query.error
    };
    $[13] = items;
    $[14] = query.error;
    $[15] = query.fetchNextPage;
    $[16] = query.isFetchingNextPage;
    $[17] = query.isLoading;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
export default useAgentReleases;
function _temp(lastPage) {
  return lastPage.meta.next ?? undefined;
}
function _temp2(p) {
  return p.data;
}